<div class="row animated fadeInDown" *ngIf="this.isEditing && !this.form.get('ativa').value">
  <div class='desativado'>
    Fucionalidade desativada
  </div>
</div>

<section class="content">

  <div class="box" [ngClass]="{'box-danger': this.isEditing && !this.form.get('ativa').value, 'box-primary': !this.isEditing, 'box-warning': this.isEditing && this.form.get('ativa').value}"
    style="margin-bottom: 5px;">

    <div class="box-body">
      <div class="row">

        <div class="col-md-6" style="border-right: solid 2px #ddd;">

          <div class="box-body">

            <div class="row">
              <div class="col-md-12">
                <p class="text-center">Tipo de Funcionalidade</p>
              </div>
            </div>

            <div class="row" style="padding-left: 15px; padding-right: 15px;">
              <div class="col-md-12">
                <div class="btn-group btn-group-justified">
                  <div class="btn-group" role="group">
                    <button type="button" class="btn" (click)="setTipoFuncionalidade(1)"
                      [ngClass]="{'btn-info': this.form.controls['tipo'].value == 1, 'btn-light' :  this.form.controls['tipo'].value!= 1 }">Janela</button>
                  </div>
                  <div class="btn-group" role="group">
                    <button type="button" class="btn" (click)="setTipoFuncionalidade(2)"
                      [ngClass]="{'btn-info': this.form.controls['tipo'].value == 2, 'btn-light' :  this.form.controls['tipo'].value != 2 }">Específica</button>
                  </div>
                  <div class="btn-group" role="group">
                    <button type="button" class="btn" (click)="setTipoFuncionalidade(3)"
                      [ngClass]="{'btn-info': this.form.controls['tipo'].value == 3, 'btn-light' :  this.form.controls['tipo'].value != 3 }">Relatorio</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="divider"></div>
            <form novalidate style="padding-top: 20px;" [formGroup]="form" id="form" (validSubmit)="submit()">

              <div class="form-row">
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <label for="">Nome da Funcionalidade</label>
                    <input class="form-control" formControlName="nome" type="text" maxlength="40" required>
                    <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                      <small *ngIf="form.get('nome').hasError('isNotUniqueNomeFuncionalidade')">Este nome de
                        funcionalidade já está em uso</small>
                    </section>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="col-md-6">
                  <div class="position-relative form-group">
                    <label for="">Agrupamento</label>
                    <input class="form-control" formControlName="grupo" type="text" maxlength="40" required>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="position-relative form-group">
                    <label for="">Rota/URI</label>
                    <input class="form-control" formControlName="rota" type="text" maxlength="30" required>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <label for="">Descrição</label>
                    <input class="form-control" formControlName="descricao" type="text" maxlength="250"
                      title="Descrição opcional detalhada da funcionalidade">
                  </div>
                </div>
              </div>


              <div class="form-row animated fadeInDown" *ngIf="this.form.controls['tipo'].value == 2">
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <label for="">Funcionalidade específica na tela</label>
                    <input class="form-control" formControlName="especifica" type="text" maxlength="30"
                      title="Funcionalidade específica na tela apontada pela rota/URI">
                  </div>
                </div>
              </div>

            </form>

          </div>
          <div class="text-center">
            <app-ball-pulse *ngIf="isProcessing"></app-ball-pulse>
          </div>

        </div>

        <!-- ------------------------------------------------------------------------- -->

        <div class="col-md-6">

          <div class="row">

            <div class="col-md-12">
              <p class="text-center">Nível de Acesso</p>
            </div>
          </div>

          <div class="row" style="padding-left: 15px; padding-right: 15px;">


            <div class="btn-group btn-group-justified">
              <div class="btn-group" role="group">
                <button type="button" class="btn" (click)="setNivelFuncionalidade(1)"
                  [ngClass]="{'btn-info': this.form.controls['nivel'].value == 1, 'btn-light' :  this.form.controls['nivel'].value!= 1 }">Solicitante</button>
              </div>
              <div class="btn-group" role="group">
                <button type="button" class="btn" (click)="setNivelFuncionalidade(2)"
                  [ngClass]="{'btn-info': this.form.controls['nivel'].value == 2, 'btn-light' :  this.form.controls['nivel'].value != 2 }">Gestor</button>
              </div>
            </div>

            <div class="btn-group btn-group-justified">
              <div class="btn-group" role="group">
                <button type="button" class="btn" (click)="setNivelFuncionalidade(3)"
                  [ngClass]="{'btn-info': this.form.controls['nivel'].value == 3, 'btn-light' :  this.form.controls['nivel'].value != 3 }">Adminstrativo</button>
              </div>
             <!--  <div class="btn-group" role="group">
                <button type="button" class="btn" (click)="setNivelFuncionalidade(4)"
                  [ngClass]="{'btn-info': this.form.controls['nivel'].value == 4, 'btn-light' :  this.form.controls['nivel'].value != 4 }">Administrador</button>
              </div> -->
            </div>
          </div>


          <div class="divider"></div>

          <div class="row mt-3">
            <div class="col-md-12">
              <p class="text-center">Possíves Permissões</p>
            </div>
          </div>

          <section *ngIf="this.form.controls['tipo'].value == 1" class="animated fadeInDown mt-3">

            <div class="form-row">
              <div class="col-md-2"></div>
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <div class="custom-checkbox custom-control">
                    <div [formGroup]="form">
                      <input class="form-check-input cp" type="checkbox" checked="true" disabled>
                    </div>
                    <label class="form-check-label" for=""> Acessar </label>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="position-relative form-group">
                  <div class="custom-checkbox custom-control">
                    <div [formGroup]="form">
                      <input formControlName="podeIncluir" class="form-check-input cp" type="checkbox" #idPodeIncluir
                        checked="true" (change)="setPossivelPermissao(2, idPodeIncluir.checked)">
                    </div>
                    <label class="form-check-label" for=""
                      [ngClass]="{'label-check' : this.form.get('podeIncluir').value == true}"> Incluir/Salvar/Executar
                    </label>
                  </div>
                </div>
              </div>

            </div>

            <div class="form-row">
              <div class="col-md-2"></div>
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <div class="custom-checkbox custom-control">
                    <div [formGroup]="form">
                      <input formControlName="podeAlterar" class="form-check-input cp" type="checkbox" #idPodeAlterar
                        checked="true" (change)="setPossivelPermissao(3, idPodeAlterar.checked)">
                    </div>
                    <label class="form-check-label" for=""
                      [ngClass]="{'label-check' : this.form.get('podeAlterar').value == true}"> Alterar/Editar
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="position-relative form-group">
                  <div class="custom-checkbox custom-control">
                    <div [formGroup]="form">
                      <input formControlName="podeListar" class="form-check-input cp" type="checkbox" #idPodeListar
                        checked="true" (change)="setPossivelPermissao(4, idPodeListar.checked)">
                    </div>
                    <label class="form-check-label" for=""
                      [ngClass]="{'label-check' : this.form.get('podeListar').value == true}">
                      Listar/Pesquisar/Imprimir
                    </label>
                  </div>

                </div>
              </div>

            </div>

            <div class="form-row">
              <div class="col-md-2"></div>
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <div class="custom-checkbox custom-control">
                    <div [formGroup]="form">
                      <input formControlName="podeExcluir" class="form-check-input cp" type="checkbox" #idPodeExcluir
                        checked="true" (change)="setPossivelPermissao(5, idPodeExcluir.checked)">
                    </div>
                    <label class="form-check-label" for=""
                      [ngClass]="{'label-check' : this.form.get('podeExcluir').value == true}"> Excluir/Inativar </label>
                  </div>
                </div>
              </div>

            </div>

          </section>

          <section *ngIf="this.form.controls['tipo'].value == 2 || this.form.controls['tipo'].value == 3"
            class="animated fadeInDown mt-3">
            <div class="form-row">
              <div class="col-md-2"></div>
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <div class="custom-checkbox custom-control">
                    <div [formGroup]="form">
                      <input class="form-check-input cp" type="checkbox" checked="true" disabled>
                    </div>
                    <label class="form-check-label" for="">
                      <span *ngIf="this.form.controls['tipo'].value == 2"> Esta Autorizado </span>
                      <span *ngIf="this.form.controls['tipo'].value == 3"> Pode Visualizar </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </section>




        </div>

      </div>

    </div>

  </div>



</section>


<div class="row mt-1">
  <div class="col-md-12">
    <div class="box" [ngClass]="{'box-danger': this.isEditing && !this.form.get('ativa').value, 'box-primary': !this.isEditing, 'box-warning': this.isEditing && this.form.get('ativa').value}">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">
              <button class="btn btn-light pl-3 pr-3" (click)="ativarDesativar()">
                  <i class="fa mr-3" [ngClass]="{'fa-check' : !this.form.get('ativa').value, 'fa-ban' : this.form.get('ativa').value}"></i>
                  {{ this.form.get('ativa').value ? 'Desativar' : 'Ativar' }} <i class="mr-2">&nbsp;</i>
                </button>
          </div>
          <div class="col-md-4">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-4">

            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="reset()">Limpar</button>
              <button type="submit" class="btn pl-5 pr-5 mr-3 btn-shadow" form="form"
                [ngClass]="{'btn-primary': !this.isEditing, 'btn-warning': this.isEditing }">
                <span *ngIf="!this.isEditing">Cadastrar</span>
                <span *ngIf="this.isEditing">Editar</span>
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<section style="min-height: 400px;">
  <div class="row">
    <div class="col">
      <div class="box" [ngClass]="{'box-danger': this.isEditing && !this.form.get('ativa').value, 'box-primary': !this.isEditing, 'box-warning': this.isEditing && this.form.get('ativa').value}">
        <div class="box-header with-border text-center">
          <h3 class="box-title ">Funcionalidades Cadastradas</h3><br />
          <span class="text-muted">Selecione para editar</span>
        </div>
        <div class="box-body">

          <div class="bx-tb-default-t1 pre-scrollable h300">
            <table class="table table-bordered table-hover">
              <thead class="thead-default">
                <tr>
                  <th class="text-center"><i *ngIf="this.isLoading"
                      class="fa fa-spinner fa-spin fa-fw pull-left"></i>Agrupamento</th>
                  <th class="text-center">Nome Funcionalidade</th>
                  <th class="text-center">Rota/URI</th>
                  <th class="text-center">Especifica</th>
                  <th class="text-center">Nível de Acesso</th>
                  <th class="text-center">Tipo</th>
                </tr>
              </thead>
              <tbody class="tbody-default">
                <tr *ngFor="let c of cadastrados" class="cp" (click)="read(c.id)"
                  [ngClass]="{'tr-info': c.id == this.form.get('id').value}">
                  <td [ngClass]="{'funcionalidadeInativa' : !c.ativa}">{{ c.grupo }}</td>
                  <td [ngClass]="{'funcionalidadeInativa' : !c.ativa}">{{ c.nome }}</td>
                  <td [ngClass]="{'funcionalidadeInativa' : !c.ativa}">{{ c.rota }}</td>
                  <td [ngClass]="{'funcionalidadeInativa' : !c.ativa}">{{ c.especifica == null ? ' - ' : c.especifica  }}</td>
                  <td class="text-center" [ngClass]="{'funcionalidadeInativa' : !c.ativa}">{{ c.nivelStr }}</td>
                  <td class="text-center" [ngClass]="{'funcionalidadeInativa' : !c.ativa}">{{ c.tipoStr }}</td>
                </tr>
                <tr *ngFor="let v of this.voids">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>


        </div>
      </div>
    </div>
  </div>

</section>